import { FC } from 'react';

import { Flex, FlexProps, Form, FormItemProps, Radio, RadioGroupProps } from 'antd';
import classNames from 'classnames';

import './RadioFormItem.scss';

interface IRadioFormItemProps {
	formItemProps: FormItemProps;
	radioGroupProps: Omit<RadioGroupProps, 'children'>;
	radioContainerProps?: Omit<FlexProps, 'children'>;
}

const RadioFormItem: FC<IRadioFormItemProps> = ({
	formItemProps,
	radioGroupProps,
	radioContainerProps = {},
}) => {
	return (
		<Form.Item
			{...formItemProps}
			className={classNames('radio-group', formItemProps.className)}
			rules={formItemProps.rules ?? [{ required: true }]}
		>
			{/* options = undefined - to use custom rendering of options */}
			<Radio.Group {...radioGroupProps} options={undefined}>
				<Flex style={{ width: '100%' }} wrap="wrap" {...radioContainerProps}>
					{radioGroupProps?.options?.map((option) => {
						if (typeof option === 'string' || typeof option === 'number') {
							return (
								<Radio key={option} value={option}>
									{option}
								</Radio>
							);
						}
						const { label, value } = option;
						return (
							<Radio key={value} value={value}>
								{label}
							</Radio>
						);
					})}
				</Flex>
			</Radio.Group>
		</Form.Item>
	);
};

export default RadioFormItem;
